import React, { useEffect } from "react";
// import { MDBIcon } from "mdbreact";

const GiphyEmbedPreview = ({
    previewOptions,
    setData,
    editMode,
    triggerResize,
}) => {
    useEffect(() => {
        triggerResize?.(); // Trigger on mount
    }, []);

    const handleImageLoad = () => {
        // Trigger resize after image has loaded to ensure correct height calculation
        triggerResize?.();
    };

    return (
        <div className="pb-4">
            {editMode && (
                <button
                    type="button"
                    onClick={() => setData("embed", null)}
                    className="absolute -top-3 -left-3 z-10 w-6 h-6 bg-red text-white text-xs rounded-full flex items-center justify-center shadow hover:bg-red-600"
                >
                    ✕
                </button>
            )}
            <img
                src={previewOptions.giphyImageUrl}
                alt="Selected Giphy"
                className="w-full h-auto rounded"
                onLoad={handleImageLoad}
            />
            {/* <p>
                <a href={previewOptions.giphyImageUrl}>Powered by GIPHY</a>
            </p> */}
        </div>
    );
};

export default GiphyEmbedPreview;
